import React from 'react';
import PropTypes from 'prop-types';

import Clear from './clear';

const CookieManager = ({ loggedIn }) => (
  <div className="cookie-manager">
    <Clear loggedIn={loggedIn} />
  </div>
);

CookieManager.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
};

export default CookieManager;
